(function () {
  if (window.__storiesWidgetAssetLoaded) return;
  window.__storiesWidgetAssetLoaded = true;

  var STORY_DURATION = 3500;

  function initStoriesWidget(widget) {
    if (!widget || widget.dataset.storiesWidgetInitialized === 'true') return;

    var container = widget.querySelector('[data-stories-container]');
    var modal = widget.querySelector('[data-story-modal]');
    var videoElement = widget.querySelector('[data-story-video]');
    var closeButtons = widget.querySelectorAll('[data-story-close]');

    if (!container || !modal || !videoElement) return;

    var items = Array.from(container.querySelectorAll('.widde-item'));
    if (!items.length) return;

    var currentIndex = 0;
    var animationId = null;
    var isModalOpen = false;

    widget.dataset.storiesWidgetInitialized = 'true';

    function stopRing() {
      if (animationId) {
        cancelAnimationFrame(animationId);
        animationId = null;
      }
    }

    function onRingComplete() {
      if (items.length === 1) {
        startRing(0);
      } else {
        startRing((currentIndex + 1) % items.length);
      }
    }

    function startRing(index, fromProgress) {
      stopRing();

      items.forEach(function (item, itemIndex) {
        var progress = item.querySelector('.ring-progress');
        if (!progress) return;

        if (itemIndex !== index) {
          progress.style.strokeDashoffset = progress._perimeter;
        }
      });

      currentIndex = index;

      var progress = items[index] && items[index].querySelector('.ring-progress');
      if (!progress) return;

      var perimeter = progress._perimeter;
      var from = fromProgress || 0;
      var startTime = performance.now() - from * STORY_DURATION;

      function tick(now) {
        var delta = now - startTime;
        var fraction = Math.min(delta / STORY_DURATION, 1);
        progress.style.strokeDashoffset = perimeter * (1 - fraction);

        if (fraction < 1) {
          animationId = requestAnimationFrame(tick);
          return;
        }

        onRingComplete();
      }

      animationId = requestAnimationFrame(tick);
    }

    function openStoryModal(videoUrl, clickedIndex) {
      if (videoUrl) {
        videoElement.src = videoUrl;
      }

      modal.classList.add('active');
      isModalOpen = true;
      currentIndex = clickedIndex;
      videoElement.muted = false;

      var playPromise = videoElement.play();
      if (playPromise !== undefined) {
        playPromise.catch(function () {
          videoElement.muted = true;
          videoElement.play();
        });
      }

      stopRing();
    }

    function closeStoryModal() {
      modal.classList.remove('active');
      videoElement.pause();
      videoElement.src = '';
      isModalOpen = false;
      startRing(currentIndex);
    }

    items.forEach(function (item, idx) {
      var progress = item.querySelector('.ring-progress');
      if (!progress) return;

      progress.setAttribute('pathLength', '100');
      progress.style.strokeDasharray = '100';
      progress.style.strokeDashoffset = '100';
      progress._perimeter = 100;

      item.addEventListener('click', function () {
        openStoryModal(item.getAttribute('data-video-url'), idx);
      });
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeStoryModal);
    });

    modal.addEventListener('click', function (event) {
      if (event.target === modal) {
        closeStoryModal();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (!isModalOpen || event.key !== 'Escape') return;
      closeStoryModal();
    });

    startRing(0);
  }

  function initStoriesWidgets(root) {
    (root || document).querySelectorAll('[data-stories-widget]').forEach(initStoriesWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initStoriesWidgets(document);
    });
  } else {
    initStoriesWidgets(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initStoriesWidgets(event.target);
  });
})();
